import httpManager from "@/app/shared/utils/httpManager";

/**
 * Exportar contactos a hubspot.
 *
 */
export async function exportContactsHubspot(clientIds, status) {
  return await httpManager.post(`/hubspot/clients/export-hubspot/`, 
    {
      contact_ids: clientIds,
    }
  );
}
